<template>
    <svg
        v-if="roundedCorners && appearance === 'thick'"
        viewBox="0 0 16 16"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M13.3337 2.6665L2.66699 13.3332"
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M2.66699 2.6665L13.3337 13.3332"
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>

    <svg
        v-else-if="appearance === 'thick'"
        viewBox="0 0 15 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M8.87881 7L13.0453 2.8335L13.9045 1.97428C14.0313 1.84753 14.0313 1.64156 13.9045 1.51481L12.9852 0.595469C12.8584 0.468719 12.6525 0.468719 12.5257 0.595469L7.5 5.62119L2.47428 0.595063C2.34753 0.468312 2.14156 0.468312 2.01481 0.595063L1.09506 1.51441C0.968312 1.64116 0.968312 1.84713 1.09506 1.97388L6.12119 7L1.09506 12.0257C0.968312 12.1525 0.968312 12.3584 1.09506 12.4852L2.01441 13.4045C2.14116 13.5313 2.34713 13.5313 2.47388 13.4045L7.5 8.37881L11.6665 12.5453L12.5257 13.4045C12.6525 13.5313 12.8584 13.5313 12.9852 13.4045L13.9045 12.4852C14.0313 12.3584 14.0313 12.1525 13.9045 12.0257L8.87881 7Z"
            fill="currentColor"
            stroke="currentColor"
        />
    </svg>
    <svg
        v-else
        viewBox="0 0 14 14"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M12.3346 1.66666L1.66797 12.3333"
            stroke="currentColor"
            stroke-width="1.4"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M1.66797 1.66666L12.3346 12.3333"
            stroke="currentColor"
            stroke-width="1.4"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
    name: "XIcon",
    props: {
        roundedCorners: {
            type: Boolean,
            default: false,
        },
        appearance: {
            type: String,
            default: "thin",
        },
    },
});
</script>
